import { render, staticRenderFns } from "./MainProducts.vue?vue&type=template&id=b0f92194&"
import script from "./MainProducts.vue?vue&type=script&lang=js&"
export * from "./MainProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports